import React, { Component } from 'react'
import _ from 'lodash'
import ModuleOverview from './ModuleOverview'
import ModuleSequence from './ModuleSequence'
import ModuleSequences from './ModuleSequences'
import ModuleSandbox from './ModuleSandbox'
import ModuleSearch from './ModuleSearch'
import StudentGroupingsContainer from '../containers/StudentGroupingsContainer/index'

const subpageTypes = {
  OVERVIEW: 'OVERVIEW',
  SEQUENCES: 'SEQUENCES',
  SANDBOX: 'SANDBOX',
  PRACTICE: 'PRACTICE',
  ENRICHMENT: 'ENRICHMENT',
  SEARCH: 'SEARCH'
}

const ModuleSubpage = ({ subpageType, module, sequence }) => {
  const formattedNgssPes = (ngssObj = {}) => _.reduce(_.map(ngssObj.ngss_pes, pe => ({ [pe.code]: [pe.description] })), (acc, obj)=>Object.assign(acc, obj), {})

  const getSubpage = ()=> {
    switch(subpageType) {
      case subpageTypes.OVERVIEW:
        return(<ModuleOverview formattedPes={formattedNgssPes(module)} module={module}/>)
      case subpageTypes.SEQUENCES:
        if(!_.isEmpty(sequence)) {
          return(
            <StudentGroupingsContainer>
              <ModuleSequence formattedPes={formattedNgssPes(sequence)} sequence={sequence} module={module} />
            </StudentGroupingsContainer>
          );
        } else {
          return(
            <ModuleSequences module={module} />
          )
        }
      case subpageTypes.SANDBOX:
        return(
          <StudentGroupingsContainer>
            <ModuleSandbox module={module}/>
          </StudentGroupingsContainer>
        )
      case subpageTypes.PRACTICE:
        return(
          <StudentGroupingsContainer>
            <ModuleSearch module={module} contentTypes={['1']} onlyQuests={true} includePractice={true} includeEnrichment={false}/>
          </StudentGroupingsContainer>
        )
      case subpageTypes.ENRICHMENT:
        return(
          <StudentGroupingsContainer>
            <ModuleSearch module={module} contentTypes={['1']} includePractice={false} includeEnrichment={true}/>
          </StudentGroupingsContainer>
        )
      case subpageTypes.SEARCH:
        return(
          <StudentGroupingsContainer>
            <ModuleSearch controls includePractice={true} includeEnrichment={true} contentTypes={['1','2']} module={module}/>
          </StudentGroupingsContainer>
        )
      default:
        console.log('Subpage not found. This is probably an error.')
        return ''
    }
  }

  return <div className='module-subpage-wrapper'>{getSubpage()}</div>
}

export { subpageTypes }
export default ModuleSubpage;
